let Brandfocus_data3_2 =[
    {
        id : 50,
        imgurl : 'img/section5/section5_3_3.jpg',
        brand : 'JILLSTUART ACC MEN',
        title : '어센틱 백팩',
        persent : '19%',
        price : '160,380',
    },
    {
        id : 51,
        imgurl : 'img/section5/section5_3_4.jpg',
        brand : 'JILLSTUART NEWYORK ACC',
        title : '베이지 포켓 미니 캔버스백',
        persent : '19%',
        price : '144,180',
    },
    {
        id : 52,
        imgurl : 'img/section5/section5_3_5.jpg',
        brand : 'JILLSTUART NEWYORK ACC',
        title : '브라운 라탄 라운드 크로스백',
        persent : '19%',
        price : '144,180',
    },
    {
        id : 53,
        imgurl : 'img/section5/section5_3_6.jpg',
        brand : 'ADIDAS',
        title : '남성 스트러터_GX6157',
        persent : '10%',
        price : '54,000',
    },
    {
        id : 54,
        imgurl : 'img/section5/section5_3_7.jpg',
        brand : 'ADIDAS',
        title : '아디다스 아딜렛 샌들 K',
        persent : '10%',
        price : '35,100',
    },
    {
        id : 55,
        imgurl : 'img/section5/section5_3_8.jpg',
        brand : 'ADIDAS',
        title : '여성 VS JOG_B74516',
        persent : '10%',
        price : '45,000',
    },
]

export default Brandfocus_data3_2;